module.exports = __webpack_public_path__ + "static/img/avatar_cert@3x.3cd099ca.png";